import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Não Conformidades',
    // Path vazio: o painel é a tela raiz do módulo, então resolve em /nao-conformidade.
    path: '',
    name: 'ncopainel',
    goesToMenu: true,
    component: () => import('@/views/nao-conformidade/painel/Index.vue'),
    meta: {
      // Sem utlTipoFornecimentoId de propósito: a tela é multi-tipo e o tipo é escolhido nas pills.
      // Se ficasse no meta, o interceptor injetaria um tipo fixo em toda requisição e o
      // permissaoService passaria a exigir a permissão daquele tipo específico para abrir a tela.
      permissions: [EPermissoes.Relatorio_NaoConformidadeQualidade],
      escopoObra: 'global'
    }
  },
  {
    description: 'Pendências de Não Conformidade',
    path: '/nao-conformidade/pendencias',
    name: 'ncopendencias',
    goesToMenu: true,
    component: () => import('@/views/nao-conformidade/pendencias/Index.vue'),
    meta: {
      // Mesmo recorte do painel: permissão por tipo de fornecimento, escolhido nas pills.
      permissions: [EPermissoes.Relatorio_NaoConformidadeQualidade],
      escopoObra: 'global'
    }
  },
  {
    description: 'Ações de Não Conformidade',
    path: '/nao-conformidade/acoes',
    name: 'ncoacoes',
    goesToMenu: true,
    component: () => import('@/views/nao-conformidade/acoes/Index.vue'),
    meta: {
      permissions: [EPermissoes.Relatorio_NaoConformidadeQualidade],
      escopoObra: 'global'
    }
  },
  {
    description: 'Ação da Não Conformidade',
    path: '/nao-conformidade/acao/:ncoId',
    name: 'ncoacao',
    goesToMenu: false,
    component: () => import('@/views/nao-conformidade/acao/Index.vue'),
    meta: {
      parentRouteName: 'ncopainel',
      permissions: [EPermissoes.NaoConformidade_Acao]
    }
  }
];
